import {AnalyticsEvent} from '../events';

import GoogleAnalyticsLogger from './GoogleAnalyticsLogger';

export const GoogleAnalytics: GoogleAnalyticsLogger = {
  logEvent: async (event: AnalyticsEvent) => {
    // TODO set analytics.defaultEventParameters
    if (__DEV__) {
      event.parameters.traffic_type = 'internal';
      // TODO traffic type for CI/CD builds
    }

    // TODO validate and sanitise parameter value to follow lower_snake_case
    window.firebase.logEvent(event.eventName, event.parameters);
  },

  // TODO set on auth
  setUserId: async (userId: string) => window.firebase.setUserId(userId),

  // TODO clear on logout
  clearUserId: async () => await window.firebase.setUserId(null),

  setUserProperties: async (props: {}) =>
    window.firebase.setUserProperties(props),

  setDefaultParameters: async (params: {}) =>
    window.firebase.setDefaultEventParameters(params),

  setSessionId: async (id: string) =>
    window.firebase.setUserProperties({session_id: id}),

  clearSessionId: async () =>
    window.firebase.setUserProperties({session_id: null}),

  clearUserSession: async () => {
    GoogleAnalytics.clearUserId();
    GoogleAnalytics.clearSessionId();
  },
};
